module.exports = __webpack_public_path__ + "img/spinaci.fd58267e.png";